export const squashRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '32\' × 21\''
    },
    points: [
      'Court: 32 feet long × 21 feet wide',
      'Front wall: 15 feet high',
      'Back wall: 7 feet high',
      'Service boxes: two boxes on each side of court'
    ],
    keyFact: 'Squash is played in an enclosed court with four walls all in play!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points to Win',
      value: '11'
    },
    points: [
      'PAR scoring (Point-A-Rally): point on every rally',
      'Games won at 11 points',
      'No need to win by 2 (first to 11 wins)',
      'Best of 5 games wins the match'
    ],
    keyFact: 'Before 2009, only the server could score points (hand-out scoring)!'
  },
  {
    title: 'Service Rules',
    type: 'do',
    diagram: {
      label: 'Service Area',
      value: 'Box'
    },
    points: [
      'Must serve from service box with at least one foot inside',
      'Ball must hit front wall above service line',
      'Must land in opposite back quarter (unless volleyed)',
      'Switch service box after winning rally'
    ],
    keyFact: 'You can continue serving from the same side until you lose the rally!'
  },
  {
    title: 'Let and Stroke Rules',
    type: 'info',
    points: [
      'Let: replay point if obstruction was minimal',
      'Stroke: point awarded if opponent blocked fair shot',
      'Referee determines let vs stroke vs no let',
      'Players must provide clear path to ball and swing'
    ],
    keyFact: 'Lets and strokes are unique to squash and crucial for fair play in the enclosed space!'
  },
  {
    title: 'Target Areas',
    type: 'info',
    points: [
      'Ball must hit front wall above tin (19 inches high)',
      'Ball can hit any wall before front wall',
      'Out line runs around top of all walls',
      'Ball is out if it hits above out line or on any line'
    ],
    keyFact: 'The tin makes a distinctive sound when hit, signaling an out ball!'
  },
  {
    title: 'Physical Contact',
    type: 'dont',
    points: [
      'Cannot obstruct opponent\'s movement to the ball',
      'Must provide direct access to front wall',
      'Must allow reasonable swing',
      'Dangerous play or racket swing results in stroke to opponent'
    ],
    keyFact: 'Squash requires constant awareness of your opponent in the shared space!'
  }
];

export const squashGoverningBodies = [
  {
    name: 'World Squash Federation',
    description: 'International governing body for squash with 145 member nations. Sets rules, organizes World Championships, and promotes the sport globally.',
    website: 'https://www.worldsquash.org'
  },
  {
    name: 'US Squash',
    description: 'National governing body for squash in the United States, overseeing tournaments, national teams, and junior development programs.',
    website: 'https://www.ussquash.org'
  }
];

export const squashTournaments = [
  {
    name: 'PSA World Tour',
    description: 'Professional Squash Association tour featuring over 200 tournaments annually with the world\'s top players.',
    website: 'https://www.psaworldtour.com'
  },
  {
    name: 'World Squash Championships',
    description: 'Annual individual championship featuring the best players competing for men\'s and women\'s world titles.',
    website: 'https://www.worldsquash.org/world-championship/'
  },
  {
    name: 'British Open',
    description: 'The oldest and most prestigious squash tournament, often called the "Wimbledon of Squash."',
    website: 'https://www.britishopensquash.com'
  },
  {
    name: 'US Open Squash',
    description: 'Major professional tournament held annually in the United States, part of the PSA World Tour.',
    website: 'https://www.usopensquash.com'
  }
];

export const squashResources = [
  {
    name: 'US Squash Events',
    website: 'https://www.ussquash.org/events/'
  },
  {
    name: 'PSA World Rankings',
    website: 'https://www.psaworldtour.com/rankings/'
  },
  {
    name: 'World Squash Federation',
    website: 'https://www.worldsquash.org'
  }
];
